/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/callback',
    layout: false,
    component: './callback',
  },
  {
    path: '/user',
    layout: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
      },
      {
        path: '/user/access-denied',
        component: './user/access-denied',
      },
    ],
  },
  {
    path: '/home',
    redirect: '/me',
    hideInMenu: true,
  },
  {
    path: '/attendance-center',
    name: '考勤中心',
    icon: 'clockCircle',
    routes: [
      {
        path: '/attendance-center/',
        hideInMenu: true,
        component: './zy-hr/CenterOverviewRedirect',
      },
      {
        path: '/attendance-center/my',
        name: '我的考勤',
        icon: 'dashboard',
        component: './zy-hr/AttendanceMyOverview',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/approval',
        name: '我的审批',
        icon: 'audit',
        component: './zy-hr/ApprovalCenter',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests',
        name: '考勤申请',
        icon: 'form',
        component: './zy-hr/AttendanceMyRequests',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/leave/create',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyLeaveRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/leave/:uuid/edit',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyLeaveRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/leave/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyLeaveRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/overtime/create',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyOvertimeRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/overtime/:uuid/edit',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyOvertimeRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/overtime/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyOvertimeRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/punch/create',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyPunchRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/punch/:uuid/edit',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyPunchRequestCreate',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/requests/punch/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceMyPunchRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/records',
        name: '打卡记录',
        icon: 'calendar',
        component: './zy-hr/AttendanceMyRecords',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/leave-balances',
        name: '我的假期',
        icon: 'wallet',
        component: './zy-hr/AttendanceMyLeaveBalances',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/monthly',
        name: '每月考勤',
        icon: 'table',
        component: './zy-hr/AttendanceMyMonthly',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/approval/leave/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceApprovalRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/approval/overtime/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceApprovalRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/attendance-center/my/approval/punch/:uuid',
        hideInMenu: true,
        component: './zy-hr/AttendanceApprovalRequestDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
    ],
  },
  {
    path: '/me',
    name: '员工中心',
    icon: 'user',
    routes: [
      { path: '/me', hideInMenu: true, component: './EmployeeSelf' },
      {
        path: '/me/profile',
        name: '我的档案',
        icon: 'user',
        component: './EmployeeSelf/Profile',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/me/certificate-requests',
        name: '我的证明申请',
        icon: 'fileDone',
        hideInMenu: true,
        component: './EmployeeSelf/CertificateRequests',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/me/lifecycle',
        name: '我的任职变化',
        icon: 'branches',
        component: './EmployeeSelf/Lifecycle',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/me/resignation-handover',
        name: '我的离职交接',
        icon: 'swap',
        component: './EmployeeSelf/ResignationHandover',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
    ],
  },
  {
    path: '/payroll-center',
    name: '薪酬中心',
    icon: 'wallet',
    routes: [
      {
        path: '/payroll-center/',
        hideInMenu: true,
        component: './zy-hr/CenterOverviewRedirect',
      },
      {
        path: '/payroll-center/my',
        hideInMenu: true,
        redirect: '/payroll-center/my/slips',
      },
      {
        path: '/payroll-center/my/slips',
        name: '我的工资条',
        icon: 'moneyCollect',
        component: './zy-hr/PayrollMy',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/payroll-center/my/slips/:uuid',
        hideInMenu: true,
        component: './zy-hr/PayrollSlipDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
    ],
  },
  {
    path: '/social-insurance-center',
    name: '社保中心',
    icon: 'safety',
    routes: [
      {
        path: '/social-insurance-center/',
        hideInMenu: true,
        component: './zy-hr/CenterOverviewRedirect',
      },
      {
        path: '/social-insurance-center/my',
        name: '我的社保',
        icon: 'insurance',
        component: './zy-hr/SocialInsuranceMy',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
    ],
  },
  {
    path: '/performance-center',
    name: '绩效中心',
    icon: 'barChart',
    routes: [
      {
        path: '/performance-center/',
        hideInMenu: true,
        component: './zy-hr/CenterOverviewRedirect',
      },
      {
        path: '/performance-center/my',
        name: '我的绩效',
        icon: 'lineChart',
        component: './zy-hr/PerformanceMy',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/performance-center/my/goals/:uuid',
        hideInMenu: true,
        component: './zy-hr/PerformanceMyDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/performance-center/my/reviews/:uuid',
        hideInMenu: true,
        component: './zy-hr/PerformanceMyDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/performance-center/my/interviews/:uuid',
        hideInMenu: true,
        component: './zy-hr/PerformanceMyDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
      {
        path: '/performance-center/my/results/:uuid',
        hideInMenu: true,
        component: './zy-hr/PerformanceMyDetail',
        wrappers: ['@/permissions/EmployeeSelfRouteGuard'],
      },
    ],
  },
  {
    path: '/settings',
    name: '设置',
    icon: 'setting',
    routes: [
      {
        path: '/settings',
        hideInMenu: true,
        component: './SettingsRedirect',
      },
      {
        path: '/settings/permissions',
        name: '权限管理',
        icon: 'safetyCertificate',
        access: 'permission',
        component: './Permissions',
      },
      {
        path: '/settings/model-settings',
        name: '模型设置',
        icon: 'robot',
        access: 'modelSettings',
        component: './ModelSettings',
      },
    ],
  },
  {
    path: '/',
    redirect: '/me',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
